@if (redirectingToPayment) {
  <app-payment-loading-screen-atom></app-payment-loading-screen-atom>
} @else {
  <div class="pb-page-bottom">
    <app-pat-payment-method-picker-block
      (selectedPaymentMethodEmitter)="onSelectedPaymentMethod($event)"
    ></app-pat-payment-method-picker-block>
  </div>
}
